// @flow
// import stores from './stores.data';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { getProductListApi, endpoints } from './api';
import { populateProductListItems } from './utils';
import { push } from 'react-router-redux';

import type { ProductList } from '../../entities';
import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs';

type ProductListAction = {
  +type: string;
  +name?: string;
  +productList?: ProductList;
  +error?: HTTPError;
};

export type ProductListState = {
  +isFetchingProductList?: boolean;
  +fetchProductListError?: HTTPError;
  +productList?: ProductList;
};

//Actions
const PRODUCT_LIST_FETCH_REQUEST = 'PRODUCT_LIST_FETCH_REQUEST';
const PRODUCT_LIST_FETCH_SUCCESS = 'PRODUCT_LIST_FETCH_SUCCESS';
const PRODUCT_LIST_FETCH_ERROR = 'PRODUCT_LIST_FETCH_ERROR';

const PRODUCT_LIST_RESET_STATE = 'PRODUCT_LIST_RESET_STATE';

export function fetchProductList(name: string): ProductListAction {
  return {
    type: PRODUCT_LIST_FETCH_REQUEST,
    name,
  };
}

export function fetchProductListSuccess(productList: ProductList): ProductListAction {
  return {
    type: PRODUCT_LIST_FETCH_SUCCESS,
    productList,
  };
}

export function fetchProductListErrorFn(error: HTTPError): ProductListAction {
  return {
    type: PRODUCT_LIST_FETCH_ERROR,
    error,
  };
}

export function resetState() {
  return {
    type: PRODUCT_LIST_RESET_STATE,
  };
}

export const actions = {
  PRODUCT_LIST_FETCH_REQUEST,
  PRODUCT_LIST_FETCH_SUCCESS,
  PRODUCT_LIST_FETCH_ERROR,
  PRODUCT_LIST_RESET_STATE,
  fetchProductList,
  fetchProductListSuccess,
  fetchProductListErrorFn,
  resetState,
};

export const initialState: ProductListState = {};

export default function reducer(state: ProductListState = initialState,
                                action: ProductListAction): ProductListState {
  switch (action.type) {
    case PRODUCT_LIST_FETCH_REQUEST:
      return {
        isFetchingProductList: true,
      };
    case PRODUCT_LIST_FETCH_SUCCESS:
      return {
        productList: populateProductListItems(action.productList),
      };
    case PRODUCT_LIST_FETCH_ERROR:
      return {
        fetchProductListError: action.error,
      };
    case PRODUCT_LIST_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// epics
export function fetchProductListEpic(action$: Observable<ProductListAction>): Observable<ProductListAction> {
  return action$.pipe(
    ofType(PRODUCT_LIST_FETCH_REQUEST),
    mergeMap(({ name }: ProductListAction) => getProductListApi(undefined, {
        route: endpoints.GET_PRODUCT_LIST.replace(':name', `${name || ''}`),
      }).pipe(
      map((productList: ProductList) => fetchProductListSuccess(productList)),
      catchError((e: HTTPError) => {
        if (e.code === 404) {
          return of(push('/new-order'));
        }
        return of(fetchProductListErrorFn(e));
      }))
    ));
}



// WEBPACK FOOTER //
// ./src/modules/product-list/duck.js